import { render, staticRenderFns } from "./06_cushion.vue?vue&type=template&id=7a6c83ce&scoped=true&"
import script from "./06_cushion.vue?vue&type=script&lang=js&"
export * from "./06_cushion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6c83ce",
  null
  
)

export default component.exports